//@flow
import { fromJS } from 'immutable';

function isObject(obj) {
  return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}

export const traverse = (obj, keys, value) => {
  const objKeys = Object.keys(obj);
  const length = keys.length;

  if (objKeys.indexOf(keys[0]) === -1) {
    obj[keys[0]] = length > 1 ? {} : value;
    if (obj[keys[0]] === value) {
      return;
    }
    const key = keys.shift();
    if (keys.length) {
      return traverse(obj[key], keys, value);
    }
    if (!isObject(value) && value !== null) {
      throw new Error(
        'Value should be an object when using a root level key for an object in the data object'
      );
    }
    obj[key] = value;
    return;
  }

  if (isObject(obj[keys[0]])) {
    const key = keys.shift();
    if (keys.length) {
      return traverse(obj[key], keys, value);
    }
    if (!isObject(value) && value !== null) {
      throw new Error(
        'Value should be an object when using a root level key for an object in the data object'
      );
    }
    obj[key] = value;
    return;
  }

  obj[keys[0]] = value;
  return;
};

const INITIAL_DWELLING = fromJS({
  location: {},
  economy: {
    utilities: []
  },
  type: {},
  size: {
    additional: []
  },
  terms: [],
  consents: [],
  timeframe: {},
  facilities: [],
  images: [],
  contact: {},
  chatable: true,
  phoneable: false,
  emailable: false,
  listingType: 'STANDARD'
});

export function getInitialDwelling(dwelling, user) {
  const serializedDwelling = dwelling ? serializeDwelling(dwelling, user) : {};
  const contact =
    user && user.get('role') !== 'admin'
      ? {
          name: user.get('name'),
          email: user.get('email'),
          phone: user.get('phone')
        }
      : {};
  return INITIAL_DWELLING.mergeDeep({ contact }, serializedDwelling);
}

function serializeDwelling(dwelling, admin) {
  const { terms, ...rest } = dwelling;
  const fromFacebook =
    admin.get('role') === 'admin' && admin.get('id') === rest.user
      ? true
      : false;
  return {
    terms: terms.map((term) => {
      if (term.key === 'PETS') {
        return {
          ...term,
          value:
            term.value === true
              ? '_TRUE'
              : term.value === false
              ? '_FALSE'
              : '_NULL'
        };
      }
      return term;
    }),
    fromFacebook,
    ...rest
  };
}
